import { render, staticRenderFns } from "./subheader-login.vue?vue&type=template&id=45cfe1d4"
import script from "./subheader-login.vue?vue&type=script&lang=js"
export * from "./subheader-login.vue?vue&type=script&lang=js"
import style0 from "./subheader-login.vue?vue&type=style&index=0&id=45cfe1d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports